import React, { useEffect, useMemo, useState } from "react";
import { Box, Flex, Icon, Text } from "@storyofams/react-ui";
import { useShopify } from "~context";

import { useRecipeCart } from "./CartProvider";
import { ToolsTable } from "./ToolsTable";

export const ToolsTab = ({ content, frame = false }) => {
  const { toolsToCart } = useRecipeCart();
  const { cart } = useShopify();
  const { setToolsPrice } = useRecipeCart();
  useEffect(() => {
    let priceTools = 0;
    content.products.forEach((item) => {
      if (toolsToCart.includes(item.id)) priceTools += Number(item.price);
    });
    setToolsPrice(Number(priceTools).toFixed(2));
  }, [cart, content, toolsToCart]);
  return (
    <Box mt={[0, "40px"]} onClick={(e) => e.stopPropagation()}>
      <Text
        display={["none", "block"]}
        fontFamily={"DINPro"}
        fontWeight={700}
        lineHeight={"28.8px"}
        fontSize={"24px"}
      >
        Tools
      </Text>
      <ToolsTable products={content.products} />
    </Box>
  );
};
